import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { WishList } from '../_models/wish-list';
import { API_URLS } from '../config/api.urls';

@Injectable({
  providedIn: 'root'
})
export class WishlistService {

  private wishlistCountSubject = new BehaviorSubject<number>(0);
  public wishlistCount$ = this.wishlistCountSubject.asObservable();

  constructor(private httpClient: HttpClient) { }

  public loadWishlistCount(userId: number): void {
    this.myWishList(userId).subscribe(
      (wishlist) => {
        this.wishlistCountSubject.next(wishlist.length);
      },
      () => {
        this.wishlistCountSubject.next(0);
      }
    );
  }

  public myWishList(userId: number): Observable<WishList[]> {
      return this.httpClient.get<WishList[]>(API_URLS.LOAD_CURRENT_USER_DETAILS + '/' + userId + '/wish_list');
  }

  public addToWishList(userId: number, offerId: number) {
    return this.httpClient.post(API_URLS.LOAD_CURRENT_USER_DETAILS + '/' + userId + '/wish_list/add', {
      userId: userId,
      offerId: offerId
    }).pipe(
      tap(() => this.loadWishlistCount(userId))
    );
  }

  public removeFromWishList(id: number, userId: number) {
    return this.httpClient.delete(API_URLS.LOAD_CURRENT_USER_DETAILS + '/' + userId + '/wish_list/' + id).pipe(
      tap(() => this.loadWishlistCount(userId))
    );
  }

}
